const createStyles = (theme, isRTL) => ({
  container: {
    padding: "clamp(16px, 3vw, 24px)",
    fontFamily: isRTL
      ? "'Cairo', 'Tajawal', -apple-system, BlinkMacSystemFont, sans-serif"
      : "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    minHeight: "100vh",
    width: "100%",
    maxWidth: "100vw",
    overflowX: "hidden",
    boxSizing: "border-box",
    background:
      theme === "dark"
        ? "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)"
        : "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
    position: "relative",
    direction: isRTL ? "rtl" : "ltr",
  },
  headerCard: {
    background:
      theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.98)",
    padding: "clamp(20px, 3vw, 28px)",
    marginTop: 0,
    marginLeft: isRTL ? 0 : 0,
    marginRight: isRTL ? 0 : 0,
    borderRadius: "clamp(16px, 2.5vw, 22px)",
    transition: "all 0.3s ease",
    backdropFilter: "blur(20px)",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.15)"
        : "1px solid rgba(0,0,0,0.06)",
    marginBottom: "clamp(24px, 4vw, 32px)",
    cursor: "pointer",
  },
  headerGradientOverlay: {
    position: "absolute",
    top: 0,
    [isRTL ? "left" : "right"]: 0,
    width: "50%",
    height: "100%",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(min(260px, 100%), 1fr))",
    gap: "clamp(18px, 3vw, 24px)",
    marginBottom: -1,
  },
  statCard: {
    background:
      theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.98)",
    padding: "clamp(20px, 3vw, 28px)",
    marginTop: 0,
    marginLeft: isRTL ? 0 : 0,
    marginRight: isRTL ? 0 : 0,
    borderRadius: "clamp(16px, 2.5vw, 22px)",
    transition: "all 0.3s ease",
    backdropFilter: "blur(20px)",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.15)"
        : "1px solid rgba(0,0,0,0.06)",
    marginBottom: "clamp(24px, 4vw, 32px)",
    cursor: "pointer",
  },
  statIconWrapper: {
    width: "clamp(52px, 9vw, 64px)",
    height: "clamp(52px, 9vw, 64px)",
    borderRadius: "clamp(14px, 2.2vw, 18px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "clamp(14px, 2.2vw, 18px)",
    position: "relative",
  },
  statValue: {
    fontSize: "clamp(28px, 5.5vw, 36px)",
    fontWeight: "900",
    color: theme === "dark" ? "#fff" : "#0f172a",
    marginBottom: "6px",
    letterSpacing: "-0.03em",
    textAlign: isRTL ? "right" : "left",
  },
  statLabel: {
    fontSize: "clamp(12px, 1.8vw, 14px)",
    color: theme === "dark" ? "rgba(255,255,255,0.75)" : "rgba(15,23,42,0.65)",
    fontWeight: "700",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    textAlign: isRTL ? "right" : "left",
  },
  statTrend: {
    fontSize: "clamp(11px, 1.6vw, 13px)",
    fontWeight: "700",
    display: "flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    gap: "6px",
    marginTop: "10px",
  },
  welcomeTitle: {
    fontSize: "25px",
    fontWeight: "900",
    color: theme === "dark" ? "#fff" : "#0f172a",
    margin: "0 0 14px 0",
    letterSpacing: "-0.03em",
    lineHeight: "1.1",
    position: "relative",
    zIndex: 1,
    textAlign: isRTL ? "right" : "left",
    display: "flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    gap: "14px",
  },
  welcomeSubtitle: {
    fontSize: "clamp(14px, 2.2vw, 17px)",
    color: theme === "dark" ? "rgba(255,255,255,0.8)" : "rgba(15,23,42,0.75)",
    lineHeight: "1.6",
    fontWeight: "500",
    position: "relative",
    zIndex: 1,
    textAlign: isRTL ? "right" : "left",
  },
  filterCard: {
    background:
      theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.98)",
    padding: "clamp(26px, 4.5vw, 36px)",
    borderRadius: "clamp(16px, 2.5vw, 22px)",
    marginBottom: "clamp(24px, 4vw, 32px)",
    backdropFilter: "blur(20px)",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.15)"
        : "1px solid rgba(0,0,0,0.06)",
    position: "relative",
    zIndex: 10,
  },
  controlsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(min(280px, 100%), 1fr))",
    gap: "clamp(18px, 3vw, 22px)",
    marginTop: "clamp(22px, 3.5vw, 28px)",
  },
  controlGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "clamp(10px, 1.6vw, 12px)",
  },
  label: {
    color: theme === "dark" ? "rgba(255,255,255,0.95)" : "#1e293b",
    fontSize: "clamp(12px, 1.7vw, 14px)",
    fontWeight: "800",
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    display: "flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    gap: "clamp(8px, 1.2vw, 10px)",
  },
  input: {
    width: "100%",
    paddingTop: "12px",
    paddingBottom: "12px",
    paddingLeft: "16px",
    paddingRight: "16px",
    borderRadius: "12px",
    border: "1px solid rgba(148, 163, 184, 0.3)",
    background:
      theme === "dark"
        ? "rgba(71, 85, 105, 0.4)"
        : "rgba(226, 232, 240, 0.6)",
    color: theme === "dark" ? "#f1f5f9" : "#334155",
    fontSize: "14px",
    fontWeight: "500",
    outline: "none",
    transition: "all 0.3s ease",
    boxSizing: "border-box",
    textAlign: isRTL ? "right" : "left",
    direction: isRTL ? "rtl" : "ltr",
  },
  textarea: {
    width: "100%",
    paddingTop: "12px",
    paddingBottom: "12px",
    paddingLeft: "16px",
    paddingRight: "16px",
    borderRadius: "12px",
    border: "1px solid rgba(148, 163, 184, 0.3)",
    background:
      theme === "dark"
        ? "rgba(71, 85, 105, 0.4)"
        : "rgba(226, 232, 240, 0.6)",
    color: theme === "dark" ? "#f1f5f9" : "#334155",
    fontSize: "14px",
    fontWeight: "500",
    outline: "none",
    transition: "all 0.3s ease",
    boxSizing: "border-box",
    minHeight: "120px",
    resize: "vertical",
    fontFamily: "inherit",
    lineHeight: "1.6",
    textAlign: isRTL ? "right" : "left",
    direction: isRTL ? "rtl" : "ltr",
  },
  select: {
    width: "10%",
    height: "100%",
    borderRadius: "12px",
    border: "1px solid rgba(148, 163, 184, 0.3)",
    background:
      theme === "dark"
        ? "rgba(71, 85, 105, 0.4)"
        : "rgba(226, 232, 240, 0.6)",
    color: theme === "dark" ? "#f1f5f9" : "#334155",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    outline: "none",
    transition: "all 0.3s ease",
    textAlign: isRTL ? "right" : "left",
    direction: isRTL ? "rtl" : "ltr",
    boxSizing: "border-box",
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
  },
  selectOption: {
    padding: "12px",
    fontWeight: "600",
    borderRadius: "clamp(12px, 1.8vw, 14px)",
    marginBottom: 30,
  },
  selectWrapper: {
    position: "relative",
    width: "100%",
  },
  selectChevron: {
    position: "absolute",
    [isRTL ? "left" : "right"]: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    color: theme === "dark" ? "rgba(255,255,255,0.6)" : "#334155",
  },
  inputWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  searchIcon: {
    position: "absolute",
    [isRTL ? "right" : "left"]: "clamp(14px, 2.2vw, 18px)",
    color: theme === "dark" ? "rgba(255,255,255,0.6)" : "#94a3b8",
    pointerEvents: "none",
  },
  customDropdown: {
    position: "relative",
    width: "100%",
  },
  dropdownTrigger: {
    background: theme === "dark" ? "rgba(255, 255, 255, 0.08)" : "#ffffff",
    border:
      theme === "dark"
        ? "2px solid rgba(255, 255, 255, 0.18)"
        : "2px solid rgba(0, 0, 0, 0.1)",
    borderRadius: "clamp(14px, 2vw, 16px)",
    padding: "clamp(16px, 2.5vw, 18px) clamp(18px, 2.8vw, 20px)",
    color: theme === "dark" ? "#ffffff" : "#0f172a",
    fontSize: "clamp(14px, 2vw, 16px)",
    fontWeight: "700",
    outline: "none",
    transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
    width: "100%",
    cursor: "pointer",
    backdropFilter: "blur(15px)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "14px",
  },
  dropdownTriggerContent: {
    display: "flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    gap: "clamp(12px, 1.8vw, 14px)",
    flex: 1,
    minWidth: 0,
  },
  dropdownIconWrapper: {
    width: "clamp(42px, 6.5vw, 48px)",
    height: "clamp(42px, 6.5vw, 48px)",
    borderRadius: "clamp(10px, 1.5vw, 12px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  dropdownTextWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0,
    flex: 1,
    textAlign: isRTL ? "right" : "left",
  },
  dropdownLabel: {
    fontSize: "clamp(14px, 2vw, 16px)",
    fontWeight: "800",
    lineHeight: "1.2",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  dropdownDescription: {
    fontSize: "clamp(11px, 1.6vw, 12px)",
    color: theme === "dark" ? "rgba(255,255,255,0.65)" : "#64748b",
    fontWeight: "600",
    lineHeight: "1.3",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  dropdownChevron: {
    flexShrink: 0,
  },
  dropdownChevronOpen: {
    transform: "rotate(180deg)",
  },
  dropdownMenu: {
    position: "absolute",
    top: "calc(100% + 10px)",
    [isRTL ? "right" : "left"]: 0,
    [isRTL ? "left" : "right"]: 0,
    background:
      theme === "dark"
        ? "linear-gradient(135deg, rgba(30, 41, 59, 0.98), rgba(51, 65, 85, 0.98))"
        : "linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.98))",
    borderRadius: "clamp(14px, 2vw, 16px)",
    backdropFilter: "blur(25px)",
    border:
      theme === "dark"
        ? "2px solid rgba(255,255,255,0.15)"
        : "2px solid rgba(0,0,0,0.08)",
    zIndex: 1000,
    maxHeight: "clamp(320px, 45vh, 450px)",
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    WebkitOverflowScrolling: "touch",
    animation: "dropdownSlideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
  },
  dropdownMenuItem: {
    padding: "clamp(14px, 2.2vw, 16px) clamp(16px, 2.5vw, 18px)",
    cursor: "pointer",
    transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
    display: "flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    gap: "clamp(12px, 1.8vw, 14px)",
    borderBottom:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.08)"
        : "1px solid rgba(0,0,0,0.06)",
  },
  dropdownMenuItemSelected: {
    background:
      theme === "dark"
        ? "rgba(59, 130, 246, 0.2)"
        : "rgba(59, 130, 246, 0.12)",
  },
  tableCard: {
    background:
      theme === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.98)",
    borderRadius: "clamp(16px, 2.5vw, 22px)",
    backdropFilter: "blur(20px)",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.15)"
        : "1px solid rgba(0,0,0,0.06)",
    overflow: "hidden",
    position: "relative",
    marginBottom: "40px",
  },
  tableWrapper: {
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "thin",
    scrollbarColor:
      theme === "dark"
        ? "rgba(255,255,255,0.3) rgba(255,255,255,0.1)"
        : "rgba(0,0,0,0.3) rgba(0,0,0,0.1)",
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    minWidth: "900px",
    direction: isRTL ? "rtl" : "ltr",
    borderRadius: "16px",
    overflow: "hidden",
  },
  th: {
    background:
      theme === "dark"
        ? "linear-gradient(135deg, rgba(51, 65, 85, 0.95), rgba(71, 85, 105, 0.95))"
        : "linear-gradient(135deg, rgba(248, 250, 252, 1), rgba(241, 245, 249, 1))",
    color: theme === "dark" ? "#f1f5f9" : "#1e293b",
    padding: "clamp(18px, 2.8vw, 22px) clamp(18px, 2.8vw, 22px)",
    textAlign: isRTL ? "right" : "left",
    fontSize: "clamp(11px, 1.7vw, 13px)",
    fontWeight: "900",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    borderBottom:
      theme === "dark"
        ? "2px solid rgba(59, 130, 246, 0.5)"
        : "2px solid rgba(59, 130, 246, 0.2)",
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    zIndex: 10,
    backdropFilter: "blur(25px)",
  },
  td: {
    padding: "clamp(18px, 2.8vw, 22px) clamp(18px, 2.8vw, 22px)",
    fontSize: "clamp(13px, 1.9vw, 15px)",
    fontWeight: "600",
    color: theme === "dark" ? "#f8fafc" : "#0f172a",
    borderBottom:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.08)"
        : "1px solid rgba(0,0,0,0.08)",
    transition: "all 0.3s ease",
    whiteSpace: "nowrap",
    textAlign: isRTL ? "right" : "left",
  },
  employeeCell: {
    display: "flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    gap: "clamp(14px, 2.2vw, 18px)",
  },
  employeeAvatar: {
    width: "clamp(44px, 7vw, 52px)",
    height: "clamp(44px, 7vw, 52px)",
    borderRadius: "150%",
    background: "linear-gradient(135deg, #2e7cba 0%, #22354d 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "800",
    fontSize: "clamp(16px, 2.8vw, 20px)",
    color: "white",
    border: "0.5px solid #22354d",
    flexShrink: 0,
    direction: "ltr",
  },
  employeeInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    minWidth: 0,
    textAlign: isRTL ? "right" : "left",
  },
  employeeName: {
    fontWeight: "800",
    fontSize: "clamp(14px, 2vw, 16px)",
    color: theme === "dark" ? "#ffffff" : "#0f172a",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  employeeDetail: {
    fontSize: "clamp(11px, 1.6vw, 13px)",
    color: theme === "dark" ? "rgba(255,255,255,0.65)" : "#64748b",
    display: "flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    gap: "6px",
    fontWeight: "600",
  },
  badge: {
    display: "inline-flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    gap: "5px",
    padding: "clamp(5px, 1vw, 7px) clamp(12px, 1.8vw, 14px)",
    borderRadius: "clamp(7px, 1.1vw, 9px)",
    fontSize: "clamp(10px, 1.5vw, 12px)",
    fontWeight: "800",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    // Badges wrap the short status/action-type text just fine, but the
    // workflow-approval-chain badge (getWorkflowApprovalLabel — e.g.
    // "Direct Manager → Second Manager → Admin Level") can be much longer.
    // whiteSpace:"nowrap" + no width cap forced it past the card edge, so
    // let it wrap instead of overflowing.
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    maxWidth: "100%",
    lineHeight: "1.5",
    boxSizing: "border-box",
  },
  actionButton: {
    padding: "clamp(10px, 1.5vw, 12px) clamp(18px, 2.5vw, 20px)",
    borderRadius: "clamp(10px, 1.5vw, 12px)",
    border: "none",
    color: "white",
    cursor: "pointer",
    fontSize: "clamp(12px, 1.7vw, 14px)",
    fontWeight: "800",
    display: "inline-flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    width: "100%",
  },
  primaryButton: {
    background:
      theme === "dark"
        ? "rgba(59, 130, 246, 0.15)"
        : "rgba(59, 130, 246, 0.1)",
    border:
      theme === "dark"
        ? "1px solid rgba(59, 130, 246, 0.4)"
        : "1px solid rgba(59, 130, 246, 0.3)",
    borderRadius: "clamp(12px, 1.8vw, 14px)",
    padding: "clamp(14px, 2.2vw, 16px) clamp(22px, 3.2vw, 26px)",
    cursor: "pointer",
    color: theme === "dark" ? "#ffffff" : "#ffffff",
    fontWeight: "800",
    fontSize: "clamp(13px, 1.9vw, 15px)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "clamp(10px, 1.5vw, 12px)",
    transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },
  secondaryButton: {
    background:
      theme === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)",
    color: theme === "dark" ? "#ffffff" : "#1e293b",
    border:
      theme === "dark"
        ? "2px solid rgba(255,255,255,0.18)"
        : "2px solid rgba(0,0,0,0.1)",
    borderRadius: "clamp(12px, 1.8vw, 14px)",
    padding: "clamp(14px, 2.2vw, 16px) clamp(22px, 3.2vw, 26px)",
    fontSize: "clamp(13px, 1.9vw, 15px)",
    fontWeight: "800",
    cursor: "pointer",
    display: "inline-flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "clamp(10px, 1.5vw, 12px)",
    transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
    backdropFilter: "blur(15px)",
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    backdropFilter: "blur(16px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    animation: "fadeIn 0.3s ease",
    padding: "clamp(18px, 3vw, 24px)",
  },
  modalContent: {
    background:
      theme === "dark"
        ? "linear-gradient(135deg, rgba(30, 41, 59, 0.99), rgba(51, 65, 85, 0.99))"
        : "linear-gradient(135deg, rgba(255, 255, 255, 0.99), rgba(248, 250, 252, 0.99))",
    padding: "clamp(28px, 4.5vw, 36px)",
    borderRadius: "clamp(18px, 2.8vw, 26px)",
    width: "100%",
    maxWidth: "1100px",
    maxHeight: "90vh",
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    WebkitOverflowScrolling: "touch",
    color: theme === "dark" ? "#ffffff" : "#0f172a",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.18)"
        : "1px solid rgba(0,0,0,0.08)",
    boxSizing: "border-box",
    backdropFilter: "blur(30px)",
    direction: isRTL ? "rtl" : "ltr",
  },
  modalHeader: {
    display: "flex",
    flexDirection: isRTL ? "row" : "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "clamp(22px, 3.5vw, 28px)",
    paddingBottom: "clamp(18px, 2.8vw, 22px)",
    borderBottom:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.15)"
        : "1px solid rgba(0,0,0,0.1)",
  },
  modalTitle: {
    fontSize: "clamp(20px, 3.8vw, 26px)",
    fontWeight: "900",
    margin: 0,
    letterSpacing: "-0.02em",
    textAlign: isRTL ? "right" : "left",
  },
  modalIconWrapper: {
    width: "clamp(48px, 7.5vw, 56px)",
    height: "clamp(48px, 7.5vw, 56px)",
    borderRadius: "clamp(13px, 2vw, 16px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [isRTL ? "marginLeft" : "marginRight"]: "clamp(14px, 2.2vw, 18px)",
  },
  closeButton: {
    background:
      theme === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)",
    border: "none",
    cursor: "pointer",
    color: theme === "dark" ? "white" : "#0f172a",
    padding: "clamp(10px, 1.5vw, 12px)",
    borderRadius: "clamp(10px, 1.5vw, 12px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
  },
  infoBox: {
    background: theme === "dark" ? "rgba(255,255,255,0.06)" : "#f8fafc",
    padding: "clamp(18px, 2.8vw, 22px)",
    borderRadius: "clamp(14px, 2.2vw, 18px)",
    border:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.12)"
        : "1px solid rgba(0,0,0,0.08)",
    marginBottom: "clamp(18px, 2.8vw, 22px)",
  },
  infoRow: {
    display: "flex",
    flexDirection: isRTL ? "row" : "row",
    justifyContent: "space-between",
    alignItems: "center",
    // Let label + value/badge wrap onto their own line when the value is
    // too wide to fit next to the label (e.g. a long workflow approval
    // chain) instead of forcing everything onto one row and overflowing.
    flexWrap: "wrap",
    rowGap: "8px",
    columnGap: "12px",
    marginBottom: "clamp(12px, 1.8vw, 14px)",
    paddingBottom: "clamp(12px, 1.8vw, 14px)",
    borderBottom:
      theme === "dark"
        ? "1px solid rgba(255,255,255,0.1)"
        : "1px solid rgba(0,0,0,0.06)",
  },
  infoLabel: {
    fontSize: "clamp(11px, 1.6vw, 13px)",
    color: theme === "dark" ? "rgba(255,255,255,0.65)" : "#64748b",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
    textAlign: isRTL ? "right" : "left",
    flexShrink: 0,
  },
  infoValue: {
    fontSize: "clamp(14px, 2vw, 16px)",
    fontWeight: "800",
    color: theme === "dark" ? "#ffffff" : "#0f172a",
    textAlign: isRTL ? "left" : "right",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    minWidth: 0,
    maxWidth: "100%",
  },
  alertBox: {
    padding: "clamp(16px, 2.4vw, 18px)",
    borderRadius: "clamp(12px, 1.8vw, 14px)",
    fontSize: "clamp(12px, 1.7vw, 14px)",
    fontWeight: "600",
    display: "flex",
    flexDirection: isRTL ? "row" : "row",
    alignItems: "center",
    gap: "clamp(12px, 1.8vw, 14px)",
    marginBottom: "clamp(18px, 2.8vw, 22px)",
  },
  successAlert: {
    background: "#dcfce7",
    border: "1px solid #86efac",
    color: "#166534",
  },
  errorAlert: {
    background: "#fee2e2",
    border: "1px solid #fca5a5",
    color: "#991b1b",
  },
  warningAlert: {
    background: "#fef3c7",
    border: "1px solid #fcd34d",
    color: "#92400e",
  },
  emptyState: {
    padding: "clamp(70px, 10vw, 100px) clamp(22px, 3.5vw, 44px)",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  emptyStateIcon: {
    marginBottom: "clamp(22px, 3.5vw, 28px)",
    opacity: 0.3,
    color:
      theme === "dark" ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
  },
  emptyStateTitle: {
    color: theme === "dark" ? "rgba(255,255,255,0.95)" : "#1e293b",
    fontSize: "clamp(20px, 3.5vw, 26px)",
    fontWeight: "800",
    marginBottom: "clamp(12px, 1.8vw, 14px)",
    letterSpacing: "-0.02em",
  },
  emptyStateText: {
    color: theme === "dark" ? "rgba(255,255,255,0.65)" : "#64748b",
    fontSize: "clamp(14px, 2vw, 16px)",
    lineHeight: "1.6",
    maxWidth: "450px",
    fontWeight: "500",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(min(280px, 100%), 1fr))",
    gap: "clamp(18px, 2.8vw, 22px)",
    marginTop: "clamp(20px, 3vw, 24px)",
  },
  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      theme === "dark"
        ? "rgba(15, 23, 42, 0.8)"
        : "rgba(255, 255, 255, 0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 100,
    borderRadius: "clamp(16px, 2.5vw, 22px)",
    backdropFilter: "blur(10px)",
  },
  loadingSpinner: {
    animation: "spin 1s linear infinite",
  },
});

export default createStyles;